import { FC } from 'react';

import Chip from 'components/Chip/Chip';
import { cn } from 'components/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from 'components/ui';

import { sidebarChipConfig } from '../constants';
import { ESideBarChipType } from '../types';

type SidebarItemChipProps = {
  type: ESideBarChipType | undefined;
  isDisabled?: boolean;
};
const SidebarMenuItemChip: FC<SidebarItemChipProps> = ({
  type,
  isDisabled
}) => {
  if (!type) return null;
  const { title, styles, disabledStateStyles, tooltip } =
    sidebarChipConfig[type];
  const chipStyles = cn(
    'w-full ml-auto',
    isDisabled && disabledStateStyles ? disabledStateStyles : styles
  );

  const chipElement = (
    <Chip variant="bordered" className={chipStyles}>
      {title}
    </Chip>
  );

  if (tooltip && !isDisabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>{chipElement}</div>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            align="start"
            className="relative rounded-md border border-base-popover bg-base-popover shadow-md py-2 px-3 w-[200px] whitespace-normal break-words text-p-s text-base-popoverForeground z-[1000] leading-relaxed"
          >
            {tooltip}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return chipElement;
};

export default SidebarMenuItemChip;
